export const amountPerShareOrTotal = [
  { value: "per_share", label: "Per share" },
  { value: "total", label: "Total" },
];

export default amountPerShareOrTotal;
